module.exports = __webpack_public_path__ + "img/Chinchilla.b8a1b1ea.jpg";